export { default as SearchRequirement } from './SearchRequirement.vue';
export { default as Pagination } from './Pagination.vue';
// index.ts에는 2개 이상의 항목이 있어야 에러x
// 한 개일 경우 index.ts를 통하지 않고 직접 import해서 사용하거나 임시로 2개 항목 사용
